import { JobOrDataset, LineageDataset, LineageJob, PipelineJob } from '../../types/lineage'
import { NodeRendererMap } from '../../../libs/graph'
import TableLineageDatasetNode from './TableLineageDatasetNode'
import TableLineageJobNode from './TableLineageJobNode'
import TableLineagePipelineNode, { TableLineagePipelineNodeData } from './TableLineagePipelineNode'

export interface TableLineageJobNodeData {
  job: LineageJob
}

export interface TableLineageDatasetNodeData {
  dataset: LineageDataset
}

export type TableLevelNodeData = TableLineageDatasetNodeData | TableLineageJobNodeData | TableLineagePipelineNodeData

export const tableLevelNodeRenderer: NodeRendererMap<JobOrDataset, TableLevelNodeData> = new Map()
  .set('JOB', TableLineageJobNode)
  .set('DATASET', TableLineageDatasetNode)
  .set('PIPELINE', TableLineagePipelineNode)
